import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Result } from '@app/models/common/result';
import { map } from 'rxjs/operators';
import { IncentiveDetail } from '@app/models/incentive/incentive-detail';

@Injectable({
  providedIn: 'root',
})
export class IncentiveService {
  constructor(private http: HttpClient) {}

  getRandomIncentive(): Observable<IncentiveDetail> {
    const url = `${environment.apiUrl}/incentive/getRandom`;
    return this.http.get<Result<IncentiveDetail>>(url).pipe(map(res => res.data));
  }

  getIncentiveDetail(period: string, viewId: string, ruleKey: string): Observable<IncentiveDetail> {
    const url = `${environment.apiUrl}/incentive/query/${period}/${viewId}/${ruleKey}`;
    return this.http.get<Result<IncentiveDetail>>(url).pipe(map(res => res.data));
  }
}
